import { QuotationUnit } from 'data-layer-cr/dist/models';
import QuotationCoverage, {
  makeEmptyQuotationCoverage,
} from 'data-layer-cr/dist/models/QuotationCoverage';
import {
  BODILY_INJURIES,
  DAMAGE_TO_THIRD_PARTIES,
  LUC,
} from 'src/constants/coveragesCodes';

type LUCChangeData = {
  savedQuotationUnit: QuotationUnit[];
  check: boolean;
  unit: QuotationUnit;
  packageSelected: string;
};

export const findCoverage = (
  coverageList: QuotationCoverage[],
  code: string,
): QuotationCoverage => {
  const coverage = coverageList.find((x) => x.coverageId === code);
  return (
    coverage || {
      ...makeEmptyQuotationCoverage(),
      insuredValue: 0,
    }
  );
};

export const getCoveragesLUCChange = ({
  check,
  savedQuotationUnit,
  unit,
  packageSelected,
}: LUCChangeData): QuotationCoverage[] => {
  const alterCoverages: QuotationCoverage[] = [];
  const BodilyInjuries = findCoverage(
    savedQuotationUnit.find(
      (item) => item.package.description === packageSelected,
    )?.coverages || [],
    BODILY_INJURIES,
  );
  const DamageToThirdParties = findCoverage(
    savedQuotationUnit.find(
      (item) => item.package.description === packageSelected,
    )?.coverages || [],
    DAMAGE_TO_THIRD_PARTIES,
  );

  if (check) {
    const LUCAmount =
      BodilyInjuries.insuredValue + DamageToThirdParties.insuredValue;
    const LUCCode = LUC;

    const newCoverage: QuotationCoverage = {
      ...makeEmptyQuotationCoverage(),
      coverageId: LUCCode,
      insuredValue: LUCAmount,
    };
    alterCoverages.push(newCoverage);
  } else {
    alterCoverages.push(BodilyInjuries);
    alterCoverages.push(DamageToThirdParties);
  }
  const regularCoverages: QuotationCoverage[] = unit.coverages.filter(
    (item) =>
      ![BODILY_INJURIES, DAMAGE_TO_THIRD_PARTIES, LUC].includes(
        item.coverageId,
      ),
  );
  return regularCoverages.concat(alterCoverages);
};
